import LayoutUtils from '../utils/layout_utils';
import Sliders from './sliders';

class SmSignUp {
  init() {
    this.waitForHubspotUtk((hutk) => {
      const input = document.getElementById('hubspotutk');
      if (hutk && input) {
        input.value = hutk;
      }
    });

    new Sliders().init();

    this.initBaseTypeTabsEvents();
    this.initBaseTypeTabs();
    this.bindEvents();
    this.selectDefaultUnitPlanTab();
    this.fillFormWithDefaults();

    document.querySelector('#user_account_billing_plan_id').dispatchEvent(new Event('change'));
  }

  fillFormWithDefaults() {
    const params = new URLSearchParams(window.location.search);
    const fields = ['account_company_name', 'email', 'account_contact_phone', 'account_min_units_managed'];

    fields.forEach(field => {
      const value = params.get(field);
      if (value !== null) {
        const input = document.querySelector(`[name="user[${field}]"]`);
        if (input) {
          input.value = value;
        }
      }
    });

    const base = params.get('base');
    if (base === 'listings') {
      document.querySelector('.js-base-plan-type[data-type="listing"]').click();
      document.querySelector('.js-listing-based-plans-select').value = params.get('bp');
    } else if (base === 'units') {
      document.querySelector('.js-base-plan-type[data-type="unit"]').click();
      const period = params.get('billing_period');
      if (period) {
        document.querySelector(`#${period}-plans`)?.click();
      }
    }

    const units = params.get('account_min_units_managed');
    const slider = document.querySelector('.js-unit-slider-wrapper .js-signup-slider-value');
    if (units && slider) {
      slider.value = units;
      slider.dispatchEvent(new Event('change'));
    }
  }

  selectDefaultUnitPlanTab() {
    let storedUnitBasedPlanId = this.fetchSelectedUnitPlanIdFromLocalStorage();
    document.querySelector(`.js-unit-based-plans-description .js-sm-tabs-link[data-id="${storedUnitBasedPlanId}"]`)?.click();
  }

  fetchSelectedUnitPlanIdFromLocalStorage() {
    const tabs = document.querySelectorAll('.js-unit-based-plans-description .js-sm-tabs-link');
    const availableIds = [...tabs].map(tab => tab.dataset.id);
    let storedUnitBasedPlanId = localStorage.getItem('sm-selected-unit-based-plan');

    // SMD-895: a returning visitor can have a period that is no longer offered
    // stored here, which used to leave the page with no period selected.
    if (!availableIds.includes(storedUnitBasedPlanId)) {
      storedUnitBasedPlanId = availableIds[0];
      localStorage.setItem('sm-selected-unit-based-plan', storedUnitBasedPlanId);
    }

    return storedUnitBasedPlanId;
  }

  setListingsBasedPlanCardContent(card, plan) {
    if (plan) {
      LayoutUtils.show(card);
      card.querySelectorAll('.js-listing-based-price').forEach(el => el.innerText = `$${Math.ceil(plan.base_rate)}/mo`);
      card.querySelectorAll('.js-listing-based-listings-included').forEach(el => el.innerText = `${plan.listings_included}`);
      card.querySelector('.js-listing-based-listings-additional-price').innerText = `$${Math.ceil(plan.listings_rate)}`;
    } else {
      LayoutUtils.hide(card);
    }
  }

  initPeriodTabsEvents(container) {
    container.querySelectorAll('.js-sm-tabs-link').forEach((t) => {
      t.addEventListener('click', (e) => {
        localStorage.setItem('sm-selected-unit-based-plan', t.dataset.id);
        if (e.currentTarget.hash === '#month-to-month-plans') {
          LayoutUtils.hide(document.querySelectorAll('.js-annual-commitment'));
          LayoutUtils.show(document.querySelectorAll('.js-cancel-anytime'));
        } else {
          LayoutUtils.show(document.querySelectorAll('.js-annual-commitment'));
          LayoutUtils.hide(document.querySelectorAll('.js-cancel-anytime'));
        }

        const unitPlansSelect = document.querySelector('.js-unit-based-plans-select');
        unitPlansSelect.value = e.currentTarget.dataset.id;
        unitPlansSelect.classList.add('highlighted');
        setTimeout(() => unitPlansSelect.classList.remove('highlighted'), 500);

        document.dispatchEvent(new CustomEvent('sm-auth-sliders:update-unit'));
      });
    });
  }

  bindEvents() {
    this.initPeriodTabsEvents(document);

    document.addEventListener('html-updated', (e) => {
      if (e.detail?.container === '.sign_up_') {
        document.dispatchEvent(new CustomEvent('SmTabReinitializationEvent'));
        this.initPeriodTabsEvents(document);
        this.initBaseTypeTabsEvents();
        this.initBaseTypeTabs();
        this.selectDefaultUnitPlanTab();
      }
    });

    const unitPlansSelect = document.querySelector('.js-unit-based-plans-select');
    unitPlansSelect.addEventListener('change', (e) => {
      document.querySelector(`[data-id="${e.target.value}"]`).click();
    });
  }

  isUnitBasedType(type) {
    return type === 'unit';
  }

  showOnlyPlansForSelectedType(type) {
    const unitBasedSelect = document.querySelector('.js-unit-based-plans-select');
    const listingBasedSelect = document.querySelector('.js-listing-based-plans-select');
    if (this.isUnitBasedType(type)) {
      LayoutUtils.show(unitBasedSelect);
      LayoutUtils.hide(listingBasedSelect);
      unitBasedSelect.removeAttribute('disabled');
      listingBasedSelect.setAttribute('disabled', 'disabled');
    } else {
      LayoutUtils.hide(unitBasedSelect);
      LayoutUtils.show(listingBasedSelect);
      listingBasedSelect.removeAttribute('disabled');
      unitBasedSelect.setAttribute('disabled', 'disabled');
    }
  }

  initBaseTypeTabsEvents() {
    document.querySelectorAll('.js-base-plan-type').forEach((tab) => {
      tab.addEventListener('click', () => {
        const baseType = tab.dataset.type;
        this.showOnlyPlansForSelectedType(baseType);
        if (!tab.classList.contains('signup-plan-base-tab--active')) {
          document.querySelectorAll('.js-base-plan-type').forEach(item => {
            item.classList.toggle('signup-plan-base-tab--active');
          });
        }

        if (this.isUnitBasedType(baseType)) {
          LayoutUtils.show(document.querySelector('.js-unit-based-plans-description'));
          LayoutUtils.hide(document.querySelector('.js-listing-based-plans-description'));
        } else {
          LayoutUtils.hide(document.querySelector('.js-unit-based-plans-description'));
          LayoutUtils.show(document.querySelector('.js-listing-based-plans-description'));
          document.querySelector('#user_account_min_units_managed').value = '';
        }
      });
    });

    this.showOnlyPlansForSelectedType(document.querySelector('.signup-plan-base-tab--active.js-base-plan-type').dataset.type);
  }

  initBaseTypeTabs() {
    document.querySelector('.signup-plan-base-tab--active.js-base-plan-type').click();
  }

  // The hubspot JS is loaded asynchronously and we need to wait for it to be loaded
  // before we can get the hubspotutk cookie
  waitForHubspotUtk(callback, maxWaitMs = 3000) {
    const interval = 100;
    const start = Date.now();

    const check = () => {
      const hutk = document.cookie
        .split('; ')
        .find(row => row.startsWith('hubspotutk='))
        ?.split('=')[1];

      if (hutk) {
        callback(hutk);
      } else if (Date.now() - start < maxWaitMs) {
        setTimeout(check, interval);
      }
    };

    check();
  }

  get unitPlansIds() {
    return document.querySelector('#new_user').dataset.unitBasedIds.split(' ');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.signup')) {
    new SmSignUp().init();
  }
});
